module.exports = __webpack_public_path__ + "img/multipart.837b97b6.png";